<template>
<v-container fill-height>
    <v-layout row wrap align-center justify-center>
        <v-flex xs12 sm12 md10 lg8 xl6>

            <form @keyup.enter.prevent="registerUser" v-if="!success">
                <v-card class="elevation-10">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>Parent Registration</v-toolbar-title>
                    </v-toolbar>
                    <v-card-text>
                        <div v-if="laravelErrors.active" class="text-xs-center">
                            <v-chip v-for="(msg,key) in laravelErrors.messages" :key="key" label color="red" text-color="white">{{ msg[0] }}
                            </v-chip>
                        </div>
                        <v-layout wrap>
                            <v-flex xs12 sm5>
                                <v-text-field name="firstName" label="First Name" prepend-icon="person" v-model="firstName" v-validate="'required'">
                                </v-text-field>
                                <div class="error--text text-xs-center">{{ errors.first('firstName') }}</div>
                            </v-flex>
                            <v-flex xs12 sm5 offset-sm1>
                                <v-text-field name="lastName" label="Last Name" prepend-icon="person" v-model="lastName" v-validate="'required'">
                                </v-text-field>
                                <div class="error--text text-xs-center">{{ errors.first('lastName') }}</div>
                            </v-flex>
                        </v-layout>

                        <v-layout wrap>
                            <v-flex xs12 sm11>
                                <v-text-field v-model="phone" name="phone" label="Phone" prepend-icon="phone" placeholder="(480) 472 - 9000" mask="(###) ### - ####" v-validate="{required: true, regex: /[0-9]{10}/ }">
                                </v-text-field>
                                <div class="error--text text-xs-center">{{ errors.first('phone') }}</div>
                            </v-flex>
                        </v-layout>

                        <v-layout wrap>
                            <v-flex xs12 sm5>
                                <v-text-field type="email" name="email" label="Email" prepend-icon="email" v-model="email" v-validate="'required|email'">
                                </v-text-field>
                                <div class="error--text text-xs-center">{{ errors.first('email') }}</div>
                            </v-flex>
                            <v-flex xs12 sm5 offset-sm1>
                                <v-text-field type="email" label="Re-type Email" prepend-icon="email" v-model="emailRetype">
                                </v-text-field>
                                <div class="green--text text-xs-center" v-if="emailsCheck.match">Emails match</div>
                                <div class="error--text text-xs-center" v-if="emailsCheck.nomatch">Emails don't match</div>
                            </v-flex>
                        </v-layout>

                        <v-layout wrap>
                            <v-flex xs12 sm5>
                                <v-text-field type="password" name="password" label="Password" prepend-icon="lock" v-model="password" v-validate="'required|min:8'">
                                </v-text-field>
                                <div class="error--text text-xs-center">{{ errors.first('password') }}</div>
                            </v-flex>
                            <v-flex xs12 sm5 offset-sm1>
                                <v-text-field type="password" label="Retype Password" prepend-icon="lock" v-model="passwordRetype">
                                </v-text-field>
                                <div class="green--text text-xs-center" v-if="passwordsCheck.match">Passwords match</div>
                                <div class="error--text text-xs-center" v-if="passwordsCheck.nomatch">Passwords don't match</div>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                    <v-card-actions class="px-5 pb-3" style="flex-wrap: wrap;">
                        <a @click="$router.push({name: 'Login'})">Return to Login</a>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" @click="registerUser" :loading="loading">Register</v-btn>
                    </v-card-actions>
                </v-card>
            </form>

            <v-card v-else>
                <v-toolbar dark color="success">
                    <v-toolbar-title>Successful Registration!</v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <p class="headline">Thanks for signing up. You may now login to add your children and start enrolling in classes.</p>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="success" @click="$router.push({name: 'Login'})">Login</v-btn>
                </v-card-actions>
            </v-card>

        </v-flex>
    </v-layout>
</v-container>
</template>

<script>
import throttle from 'lodash.throttle'

export default {
    data() {
        return {
            success: false,
            loading: false,
            firstName: '',
            lastName: '',
            phone: '',
            email: '',
            emailRetype: '',
            password: '',
            passwordRetype: ''
        }
    },
    computed: {
        emailsCheck() {
            let match = this.email === this.emailRetype
            let empty = (this.emailRetype.length === 0)
            return {
                match: (match && !empty),
                nomatch: (!match && !empty)
            }
        },
        passwordsCheck() {
            let match = this.password === this.passwordRetype
            let empty = (this.passwordRetype.length === 0)
            return {
                match: (match && !empty),
                nomatch: (!match && !empty)
            }
        },
        laravelErrors() {
            return this.$store.state.errorModule.validation
        }
    },
    methods: {
        registerUser: throttle(function () {
            this.loading = true
            this.$store.commit('clearErrors')

            this.$validator.validateAll().then((result) => {
                if (result && this.emailsCheck.match && this.passwordsCheck.match) {
                    let user = {
                        first_name: this.firstName,
                        last_name: this.lastName,
                        email: this.email,
                        password: this.password,
                        phone: this.phone,
                        role: 'parent'
                    }
                    // timer is for UX, so user knows button was clicked and form was submitted
                    setTimeout(() => {
                        this.$store.dispatch('registerUser', user)
                            .then(() => this.success = true)
                            .catch(() => this.loading = false)
                    }, 500)

                } else {
                    this.loading = false
                }
            })
        }, 1000)
    },
    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.$store.commit('clearErrors')
        })
    },
}
</script>
